//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductHead from "~/components/loading-placeholders/product-list-ph.vue";
import FullWidthVideo from "~/components/video-elements/fullWidthVideo.vue";
import subNavSelection from "~/components/header-item-selection";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
import ProductPresentationHead from "~/components/loading-placeholders/product-presentation-head-pl.vue";
export default {
  data() {
    return {};
  },
  components: {
    ProductHead,
    BannerTypeProduct,
    subNavSelection,
    FullWidthVideo,
    ProductPresentationHead,
  },
  mounted() {
    this.$store.dispatch("tea-products/getNaturalInfusions");
    this.$store.dispatch("tea-products/geIngredients");
  },

  computed: {
    pageData() {
      if (this.$store.state["tea-products"].naturalInfusions != null) {
        return Object.assign(
          this.$store.state["tea-products"].naturalInfusions.our_ingredients,
          { links: this.$store.state["tea-products"].naturalInfusions.links }
        );
      }
    },

    ourIngredients() {
      if (this.$store.state["tea-products"].ingredientsPage != null) {
        return this.$store.state["tea-products"].ingredientsPage;
      }
    },
  },
  watch: {
    pageData() {
      this.$nuxt.$loading.finish();
    },
  },
};
